<template>
  <div>
    <div class="row page-heading mx-0">
      <div class="col-8 input module_heading" role="heading" aria-level="1">
        <span class="module_icon icon-plug">
          <i class="fa fa-plug fa-rotate-90" aria-hidden="true"></i>
        </span>
        <span class="module_type_name" style="padding: 6px 5px 0 3px !important;">Connector Management</span>
      </div>
      <div class="col-4 submit btn-container text-right">
        <button type="button" class="btn btn-primary" @click.prevent="save" aria-label="save">save</button>
        <button type="button" class="btn btn-primary" @click.prevent="cancel" aria-label="cancel">cancel</button>
      </div>
    </div>

    <div class="content-section-with-bg-brdr">
      <div class="row field-row">
        <div class="col-11 row">
          <div class="col-2 form-label" id="connectorName">Name <sup>*</sup></div>
          <div class="col-4">
            <b-form-input v-model.trim="connectorName" :state="connectorNameState"
              aria-labelledby="connectorName" placeholder="Connector Name"
              @blur="$v.connectorName.$touch()"
              aria-describedby="connectorNameFeedback" v-focus style="height: 40px !important;">
            </b-form-input>
            <b-form-invalid-feedback id="connectorNameFeedback">
              Name must not be empty
            </b-form-invalid-feedback>
          </div>
        </div>
      </div>

      <div class="row field-row">
        <div class="col-11 row">
          <div class="col-2 form-label" id="authType">Auth Type</div>
          <div class="col-4">
            <select class="form-control" v-model="authType" style="width: 98%; height: 30px !important;">
              <option v-for="option in authTypeOptions" v-bind:value="option" >{{ option }}</option>
            </select>
          </div>
          <div class="col-2 form-label" id="description">Description</div>
          <div class="col-4">
            <b-form-input v-model.trim="description" placeholder="Connector Description" style="height: 40px !important;"></b-form-input>
          </div>
        </div>
      </div>

      <div class="row field-row">
        <div class="col-11 row">
          <div class="col-2 form-label" id="type">Type <sup>*</sup></div>
          <div class="col-4">
            <select class="form-control" v-model="type" style="width: 98%; height: 30px !important;">
              <option v-for="option in typeOptions" v-bind:value="option" >{{ option }}</option>
            </select>
          </div>
          <div class="col-2 form-label" id="lmsType">Sub Type <sup>*</sup></div>
          <div class="col-4">
            <select class="form-control" v-model="lmsType" style="width: 98%; height: 30px !important;">
              <option v-for="option in lmsTypeOptions" v-bind:value="option" >{{ option }}</option>
            </select>
          </div>
        </div>
      </div>

      <template v-if="lmsType === 'Salesforce'">
        <div class="row field-row">
          <div class="col-11 row">
            <div class="col-2 form-label" id="authURL">Authorization URL <sup>*</sup></div>
            <div class="col-4">
              <b-form-input v-model.trim="authURL" :state="authURLState"
                aria-labelledby="authURL" placeholder="http://"
                @blur="$v.authURL.$touch()"
                aria-describedby="authURLFeedback" style="height: 40px !important;">
              </b-form-input>
              <b-form-invalid-feedback id="authURLFeedback">
                Authorization URL must be valid
              </b-form-invalid-feedback>
            </div>
            <div class="col-2 form-label" id="serviceBaseURL">Service Base URL <sup>*</sup></div>
            <div class="col-4">
              <b-form-input v-model.trim="serviceBaseURL" :state="serviceBaseURLState"
                aria-labelledby="serviceBaseURL" placeholder="http://"
                @blur="$v.serviceBaseURL.$touch()"
                aria-describedby="serviceBaseURLFeedback" style="height: 40px !important;">
              </b-form-input>
              <b-form-invalid-feedback id="serviceBaseURLFeedback">
                Service Base URL must be valid
              </b-form-invalid-feedback>
            </div>
          </div>
        </div>
        <div class="row field-row">
          <div class="col-11 row">
            <div class="col-2 form-label" id="consumerKey">Client ID <sup>*</sup></div>
            <div class="col-4">
              <b-form-input v-model.trim="consumerKey" :state="consumerKeyState"
                aria-labelledby="consumerKey" placeholder="Client ID"
                @blur="$v.consumerKey.$touch()"
                aria-describedby="consumerKeyFeedback" style="height: 40px !important;">
              </b-form-input>
              <b-form-invalid-feedback id="consumerKeyFeedback">
                Client ID must not be empty
              </b-form-invalid-feedback>
            </div>
            <div class="col-2 form-label" id="sharedSecret">Client Secret <sup>*</sup></div>
            <div class="col-4">
              <b-form-input v-model.trim="sharedSecret" :state="sharedSecretState"
                aria-labelledby="sharedSecret" placeholder="Client Secret"
                @blur="$v.sharedSecret.$touch()"
                aria-describedby="sharedSecretFeedback" style="height: 40px !important;">
              </b-form-input>
              <b-form-invalid-feedback id="sharedSecretFeedback">
                Client Secret must not be empty
              </b-form-invalid-feedback>
            </div>
          </div>
        </div>
        <div class="row field-row">
          <div class="col-11 row">
            <div class="col-2 form-label" id="consumerKey">Username<sup>*</sup></div>
            <div class="col-4">
              <b-form-input v-model.trim="salesforceUsername" :state="salesforceUsernameState"
                aria-labelledby="salesforceUsername" placeholder="Salesforce Username"
                @blur="$v.salesforceUsername.$touch()"
                aria-describedby="salesforceUsernameFeedback" style="height: 40px !important;">
              </b-form-input>
              <b-form-invalid-feedback id="usernameFeedback">
                Salesforce Username must not be empty
              </b-form-invalid-feedback>
            </div>
            <div class="col-2 form-label" id="sharedSecret">Password <sup>*</sup></div>
            <div class="col-4">
              <b-form-input v-model.trim="salesforcePassword" :state="salesforcePasswordState"
                aria-labelledby="salesforcePassword" placeholder="Salesforce Password"
                @blur="$v.salesforcePassword.$touch()"
                aria-describedby="salesforcePasswordFeedback" style="height: 40px !important;">
              </b-form-input>
              <b-form-invalid-feedback id="salesforcePasswordFeedback">
                Salesforce Password must not be empty
              </b-form-invalid-feedback>
            </div>
          </div>
        </div>
        <div class="row field-row">
          <div class="col-11 row">
            <div class="col-2 form-label" id="consumerKey">Security Token<sup>*</sup></div>
            <div class="col-4">
              <b-form-input v-model.trim="salesforceSecurityToken" :state="salesforceSecurityTokenState"
                aria-labelledby="consumerKey" placeholder="Salesforce Security Token"
                @blur="$v.salesforceSecurityToken.$touch()"
                aria-describedby="salesforceSecurityTokenFeedback" style="height: 40px !important;">
              </b-form-input>
              <b-form-invalid-feedback id="usernameFeedback">
                Salesforce Security Token must not be empty
              </b-form-invalid-feedback>
            </div>
          </div>
        </div>
      </template>

      <template v-if="lmsType !== 'Google' && lmsType !== 'Salesforce'">
        <template v-if="lmsType === 'SFTP'">
          <div class="row field-row">
            <div class="col-11 row">
              <div class="col-2 form-label" id="sftpHost">Host <sup>*</sup></div>
              <div class="col-4">
                <b-form-input v-model.trim="sftpHost" :state="sftpHostState"
                  aria-labelledby="sftpHost" placeholder="Host Name or IP address"
                  @blur="$v.sftpHost.$touch()"
                  aria-describedby="sftpHostFeedback" style="height: 40px !important;">
                </b-form-input>
                <b-form-invalid-feedback id="sftpHostFeedback">
                  Host must be valid
                </b-form-invalid-feedback>
              </div>
              <div class="col-2 form-label" id="sftpDataDirectory">CSV File Location <sup>*</sup></div>
              <div class="col-4">
                <b-form-input v-model.trim="sftpDataDirectory" :state="sftpDataDirectoryState"
                  aria-labelledby="sftpDataDirectory" placeholder="/home/username/data"
                  @blur="$v.sftpDataDirectory.$touch()"
                  aria-describedby="sftpDataDirectoryFeedback" style="height: 40px !important;">
                </b-form-input>
                <b-form-invalid-feedback id="sftpDataDirectoryFeedback">
                  CSV File Location must not be empty
                </b-form-invalid-feedback>
              </div>
            </div>
          </div>
          <div class="row field-row">
            <div class="col-11 row">
              <div class="col-2 form-label" id="consumerKey">User Name <sup>*</sup></div>
              <div class="col-4">
                <b-form-input v-model.trim="consumerKey" :state="consumerKeyState"
                  aria-labelledby="consumerKey" placeholder="Consumer Key"
                  @blur="$v.consumerKey.$touch()"
                  aria-describedby="consumerKeyFeedback" style="height: 40px !important;">
                </b-form-input>
                <b-form-invalid-feedback id="consumerKeyFeedback">
                  Consumer Key must not be empty
                </b-form-invalid-feedback>
              </div>
              <div class="col-2 form-label" id="sharedSecret">Password <sup>*</sup></div>
              <div class="col-4">
                <b-form-input v-model.trim="sharedSecret" :state="sharedSecretState"
                  aria-labelledby="sharedSecret" placeholder="Shared Secret"
                  @blur="$v.sharedSecret.$touch()"
                  aria-describedby="sharedSecretFeedback" style="height: 40px !important;">
                </b-form-input>
                <b-form-invalid-feedback id="sharedSecretFeedback">
                  Shared Secret must not be empty
                </b-form-invalid-feedback>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <template v-if="lmsType === 'OKTA'">
            <div class="row field-row">
              <div class="col-11 row">
                <div class="col-2 form-label" id="authURL">API Base URL <sup>*</sup></div>
                <div class="col-4">
                  <b-form-input v-model.trim="authURL" :state="authURLState"
                    aria-labelledby="authURL" placeholder="http://"
                    @blur="$v.authURL.$touch()"
                    aria-describedby="authURLFeedback" style="height: 40px !important;">
                  </b-form-input>
                  <b-form-invalid-feedback id="authURLFeedback">
                    API Base URL must be valid
                  </b-form-invalid-feedback>
                </div>
                <div class="col-2 form-label" id="serviceBaseURL">App Login URL <sup>*</sup></div>
                <div class="col-4">
                  <b-form-input v-model.trim="serviceBaseURL" :state="serviceBaseURLState"
                    aria-labelledby="serviceBaseURL" placeholder="http://"
                    @blur="$v.serviceBaseURL.$touch()"
                    aria-describedby="serviceBaseURLFeedback" style="height: 40px !important;">
                  </b-form-input>
                  <b-form-invalid-feedback id="serviceBaseURLFeedback">
                    App Login URL must be valid
                  </b-form-invalid-feedback>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="row field-row">
              <div class="col-11 row">
                <div class="col-2 form-label" id="authURL">Authorization URL <sup>*</sup></div>
                <div class="col-4">
                  <b-form-input v-model.trim="authURL" :state="authURLState"
                    aria-labelledby="authURL" placeholder="http://"
                    @blur="$v.authURL.$touch()"
                    aria-describedby="authURLFeedback" style="height: 40px !important;">
                  </b-form-input>
                  <b-form-invalid-feedback id="authURLFeedback">
                    Authorization URL must be valid
                  </b-form-invalid-feedback>
                </div>
                <div class="col-2 form-label" id="serviceBaseURL">Service Base URL <sup>*</sup></div>
                <div class="col-4">
                  <b-form-input v-model.trim="serviceBaseURL" :state="serviceBaseURLState"
                    aria-labelledby="serviceBaseURL" placeholder="http://"
                    @blur="$v.serviceBaseURL.$touch()"
                    aria-describedby="serviceBaseURLFeedback" style="height: 40px !important;">
                  </b-form-input>
                  <b-form-invalid-feedback id="serviceBaseURLFeedback">
                    Service Base URL must be valid
                  </b-form-invalid-feedback>
                </div>
              </div>
            </div>
          </template>

          <template v-if="(lmsType === 'D2L') || (lmsType === 'OKTA') || (lmsType === 'Lumens') || (lmsType === 'AUTH0') || (lmsType === 'Canvas') || (lmsType === 'Skyprep') || (lmsType === 'Sail') || (lmsType === 'Unmudl')">
            <template v-if="lmsType === 'OKTA'">
              <div class="row field-row">
                <div class="col-11 row">
                  <div class="col-2 form-label" id="consumerKey">Token Text <sup>*</sup></div>
                  <div class="col-4">
                    <b-form-input v-model.trim="consumerKey" :state="consumerKeyState"
                      aria-labelledby="consumerKey" placeholder="Token Text"
                      @blur="$v.consumerKey.$touch()"
                      aria-describedby="consumerKeyFeedback" style="height: 40px !important;">
                    </b-form-input>
                    <b-form-invalid-feedback id="consumerKeyFeedback">
                      Token Text must not be empty
                    </b-form-invalid-feedback>
                  </div>
                  <div class="col-2 form-label" id="sharedSecret">API Token <sup>*</sup></div>
                  <div class="col-4">
                    <b-form-input v-model.trim="sharedSecret" :state="sharedSecretState"
                      aria-labelledby="sharedSecret" placeholder="API Token"
                      @blur="$v.sharedSecret.$touch()"
                      aria-describedby="sharedSecretFeedback" style="height: 40px !important;">
                    </b-form-input>
                    <b-form-invalid-feedback id="sharedSecretFeedback">
                      API Token must not be empty
                    </b-form-invalid-feedback>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="row field-row">
                <div class="col-11 row">
                  <div class="col-2 form-label" id="consumerKey">Consumer Key <sup>*</sup></div>
                  <div class="col-4">
                    <b-form-input v-model.trim="consumerKey" :state="consumerKeyState"
                      aria-labelledby="consumerKey" placeholder="Consumer Key"
                      @blur="$v.consumerKey.$touch()"
                      aria-describedby="consumerKeyFeedback" style="height: 40px !important;">
                    </b-form-input>
                    <b-form-invalid-feedback id="consumerKeyFeedback">
                      Consumer Key must not be empty
                    </b-form-invalid-feedback>
                  </div>
                  <div class="col-2 form-label" id="sharedSecret">Shared Secret <sup>*</sup></div>
                  <div class="col-4">
                    <b-form-input v-model.trim="sharedSecret" :state="sharedSecretState"
                      aria-labelledby="sharedSecret" placeholder="Shared Secret"
                      @blur="$v.sharedSecret.$touch()"
                      aria-describedby="sharedSecretFeedback" style="height: 40px !important;">
                    </b-form-input>
                    <b-form-invalid-feedback id="sharedSecretFeedback">
                      Shared Secret must not be empty
                    </b-form-invalid-feedback>
                  </div>
                </div>
              </div>
            </template>
          </template>

          <template v-if="lmsType === 'Fedora'">
            <div class="row field-row">
              <div class="col-11 row">
                <div class="col-2 form-label" id="userId">User Id <sup>*</sup></div>
                <div class="col-4">
                  <b-form-input v-model.trim="consumerKey" :state="consumerKeyState"
                    aria-labelledby="userId" placeholder="User Id"
                    @blur="$v.consumerKey.$touch()"
                    aria-describedby="userIdFeedback" style="height: 40px !important;">
                  </b-form-input>
                  <b-form-invalid-feedback id="userIdFeedback">
                    User Id must not be empty
                  </b-form-invalid-feedback>
                </div>
                <div class="col-2 form-label" id="password">Password <sup>*</sup></div>
                <div class="col-4">
                  <b-form-input v-model.trim="sharedSecret" :state="sharedSecretState"
                    aria-labelledby="password" placeholder="Password"
                    @blur="$v.sharedSecret.$touch()"
                    aria-describedby="passwordFeedback" style="height: 40px !important;">
                  </b-form-input>
                  <b-form-invalid-feedback id="passwordFeedback">
                    Password must not be empty
                  </b-form-invalid-feedback>
                </div>
              </div>
            </div>

            <div class="row field-row">
              <div class="col-11 row">
                <div class="col-2 form-label" id="repoId">Repo Id <sup>*</sup></div>
                <div class="col-4">
                  <b-form-input v-model.trim="repoId" :state="repoIdState"
                    aria-labelledby="repoId" placeholder="Repo Id"
                    @blur="$v.repoId.$touch()"
                    aria-describedby="repoIdFeedback" style="height: 40px !important;">
                  </b-form-input>
                  <b-form-invalid-feedback id="repoIdFeedback">
                    Repo Id must not be empty
                  </b-form-invalid-feedback>
                </div>
                <div class="col-2 form-label" id="syncInterval">Sync Interval (Minutes) <sup>*</sup></div>
                <div class="col-4">
                  <b-form-input v-model.trim="syncIntervalInMinutes" :state="syncIntervalState"
                    aria-labelledby="syncInterval" placeholder="Sync Interval"
                    @blur="$v.syncIntervalInMinutes.$touch()"
                    aria-describedby="syncIntervalFeedback" style="height: 40px !important;">
                  </b-form-input>
                  <b-form-invalid-feedback id="syncIntervalFeedback">
                    Sync Interval must be numeric
                  </b-form-invalid-feedback>
                </div>
              </div>
            </div>
          </template>

          <template v-if="lmsType === 'Kaltura'">
            <div class="row field-row">
              <div class="col-11 row">
                <div class="col-2 form-label" id="userId">User Id <sup>*</sup></div>
                <div class="col-4">
                  <b-form-input v-model.trim="consumerKey" :state="consumerKeyState"
                    aria-labelledby="userId" placeholder="User Id"
                    @blur="$v.consumerKey.$touch()"
                    aria-describedby="userIdFeedback" style="height: 40px !important;">
                  </b-form-input>
                  <b-form-invalid-feedback id="userIdFeedback">
                    User Id must not be empty
                  </b-form-invalid-feedback>
                </div>
                <div class="col-2 form-label" id="adminSecret">Admin Secret <sup>*</sup></div>
                <div class="col-4">
                  <b-form-input v-model.trim="sharedSecret" :state="sharedSecretState"
                    aria-labelledby="adminSecret" placeholder="Admin Secret"
                    @blur="$v.sharedSecret.$touch()"
                    aria-describedby="adminSecretFeedback" style="height: 40px !important;">
                  </b-form-input>
                  <b-form-invalid-feedback id="adminSecretFeedback">
                    Admin Secret must not be empty
                  </b-form-invalid-feedback>
                </div>
              </div>
            </div>

            <div class="row field-row">
              <div class="col-11 row">
                <div class="col-2 form-label" id="partnerId">Partner Id <sup>*</sup></div>
                <div class="col-4">
                  <b-form-input v-model.trim="repoId" :state="repoIdState"
                    aria-labelledby="partnerId" placeholder="Partner Id"
                    @blur="$v.repoId.$touch()"
                    aria-describedby="partnerIdFeedback" style="height: 40px !important;">
                  </b-form-input>
                  <b-form-invalid-feedback id="partnerIdFeedback">
                    Partner Id must not be empty
                  </b-form-invalid-feedback>
                </div>
                <div class="col-2 form-label" id="syncInterval">Sync Interval (Minutes) <sup>*</sup></div>
                <div class="col-4">
                  <b-form-input v-model.number="syncIntervalInMinutes" :state="syncIntervalState"
                    aria-labelledby="syncInterval" placeholder="Shared Secret"
                    @blur="$v.syncIntervalInMinutes.$touch()"
                    aria-describedby="syncIntervalFeedback" style="height: 40px !important;">
                  </b-form-input>
                  <b-form-invalid-feedback id="syncIntervalFeedback">
                    Sync Interval must not be empty
                  </b-form-invalid-feedback>
                </div>
              </div>
            </div>
          </template>
          <template v-if="lmsType === 'Populi'">
            <div class="row field-row">
              <div class="col-11 row">
                <div class="col-2 form-label" id="userId">User Id <sup>*</sup></div>
                <div class="col-4">
                  <b-form-input v-model.trim="consumerKey" :state="consumerKeyState"
                    aria-labelledby="userId" placeholder="User Id"
                    @blur="$v.consumerKey.$touch()"
                    aria-describedby="userIdFeedback" style="height: 40px !important;">
                  </b-form-input>
                  <b-form-invalid-feedback id="userIdFeedback">
                    User Id must not be empty
                  </b-form-invalid-feedback>
                </div>
                <div class="col-2 form-label" id="adminSecret">Admin Secret <sup>*</sup></div>
                <div class="col-4">
                  <b-form-input v-model.trim="sharedSecret" :state="sharedSecretState"
                    aria-labelledby="adminSecret" placeholder="Password"
                    @blur="$v.sharedSecret.$touch()"
                    aria-describedby="adminSecretFeedback" style="height: 40px !important;">
                  </b-form-input>
                  <b-form-invalid-feedback id="adminSecretFeedback">
                    Password must not be empty
                  </b-form-invalid-feedback>
                </div>
              </div>
            </div>

          </template>

          <template v-if="lmsType === 'PopuliV2'">
            <div class="row field-row">
              <div class="col-11 row">
                <div class="col-2 form-label" id="userId">
                  Access Key <sup>*</sup>
                </div>
                <div class="col-4">
                  <b-form-input v-model.trim="accessKey" :state="accessKeyState"
                    aria-labelledby="userId" placeholder="accessKey"
                    @blur="$v.accessKey.$touch()"
                    aria-describedby="accessKeyFeedback" style="height: 40px !important;">
                  </b-form-input>
                  <b-form-invalid-feedback id="accessKeyFeedback">
                    accessKey must not be empty
                  </b-form-invalid-feedback>
                </div>
              </div>    
            </div>
          </template>

          <template v-if="!((lmsType === 'D2L') || (lmsType === 'OKTA') || (lmsType === 'Lumens') || (lmsType === 'SFTP') || (lmsType === 'Unmudl') || (lmsType === 'Skyprep') || (lmsType === 'Populi') || (lmsType === 'PopuliV2'))">
            <div class="row field-row">
              <div class="col-11 row">
                <div class="col-2 form-label" id="type">Create Pragya Content As <sup>*</sup></div>
                <div class="col-4">
                  <div class="field-row-radio" v-for="option in createContentAsOptions">
                    <template v-if="!((option.value === 'DeepCopy') && (lmsType !== 'Blackboard'))">
                      <input type="radio" :value="option.value" v-model="createContentAs">{{option.text}}</input>
                    </template>
                  </div>
                </div>
                <template v-if="lmsType === 'Canvas'">
                  <div class="col-2 form-label" id="playerId">Import Canvas Content As <sup>*</sup></div>
                  <div class="col-4">
                    <div class="field-row-radio" v-for="option in importContentAsOptions">
                      <input type="radio" :value="option.value" v-model="importContentAs">{{option.text}}</input>
                    </div>
                  </div>
                </template>
                <template v-if="lmsType === 'Kaltura'">
                  <div class="col-2 form-label" id="playerId">Player Id <sup>*</sup></div>
                  <div class="col-4">
                    <b-form-input v-model.trim="playerId" :state="playerIdState"
                      aria-labelledby="playerId" placeholder="Player Id"
                      @blur="$v.playerId.$touch()"
                      aria-describedby="playerIdFeedback" style="height: 40px !important;">
                    </b-form-input>
                    <b-form-invalid-feedback id="playerIdFeedback">
                      Player Id must not be empty
                    </b-form-invalid-feedback>
                  </div>
                </template>
                <template v-if="lmsType === 'Blackboard'">
                  <div class="col-2 form-label" id="userMapping">User Mapping <sup>*</sup></div>
                  <div class="col-4">
                    <select class="form-control" v-model="userMapping" style="width: 98%; height: 30px !important;">
                      <option v-for="option in userMappingOptions" v-bind:value="option" >{{ option }}</option>
                    </select>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </template>
      </template>
    </div>

    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>

  </div>
</template>

<script>
  import Vue from 'vue'
  import { mapActions } from 'vuex'
  import Vuelidate from 'vuelidate'
  import {required, url, numeric, ipAddress, or} from 'vuelidate/lib/validators'
  const hostname = (value) => url('http://' + value)
  Vue.use(Vuelidate)
  Vue.directive('focus', {
    inserted (el) {
      el.focus()
    }
  })

  export default {
    name: 'connector-create',
    props: ['uuid'],
    data () {
      return {
        connectorName: null,
        connectorNameState: null,
        description: null,
        consumerKey: null,
        consumerKeyState: null,
        accessKey: null,
        accessKeyState: null,
        sharedSecret: null,
        sharedSecretState: null,
        salesforceUsername: null,
        salesforceUsernameState: null,
        salesforcePassword: null,
        salesforcePasswordState: null,
        salesforceSecurityToken: null,
        salesforceSecurityTokenState: null,
        authURL: null,
        authURLState: null,
        serviceBaseURL: null,
        serviceBaseURLState: null,
        repoId: null,
        repoIdState: null,
        playerId: null,
        playerIdState: null,
        syncIntervalInMinutes: 0,
        syncIntervalState: null,
        sftpHost: null,
        sftpHostState: null,
        sftpDataDirectory: null,
        sftpDataDirectoryState: null,
        type: 'SIS',
        typeOptions: ['API', 'SIS', 'LMS', 'SSO', 'SFTP'],
        authType: 'ByLogin',
        authTypeOptions: ['ByLogin', 'OAuth2', 'OpenId'],
        importContentAs: 'DeepCopy',
        importContentAsOptions: [{value: 'ExternalUrl', text: 'External URL'}, {value: 'DeepCopy', text: 'Deep Copy'}],
        createContentAs: 'ExternalUrl',
        createContentAsOptions: [{value: 'ExternalUrl', text: 'External URL'}, {value: 'LtiLink', text: 'LTI Link'}, {value: 'DeepCopy', text: 'Deep Copy'}],
        userMapping: 'EMAIL_SURNAME_GIVENNAME',
        userMappingOptions: ['EMAIL_SURNAME_GIVENNAME', 'BB_USERNAME', 'BB_BATCH_UID'],
        lmsType: 'Skyprep',
        lmsTypeOptions: ['D2L', 'SFTP', 'OKTA', 'AUTH0', 'Sail', 'Sakai', 'Lumens', 'Moodle', 'Unmudl', 'Skyprep', 'Canvas', 'Fedora', 'Kaltura', 'Google', 'Blackboard', 'Salesforce', 'Populi', 'PopuliV2']
      }
    },

    validations: {
      connectorName: {
        required
      },
      lmsType: {
        required
      },
      authURL: {
        required,
        url
      },
      serviceBaseURL: {
        required,
        url
      },
      consumerKey: {
        required
      },
      accessKey: {
        required
      },
      sharedSecret: {
        required
      },
      salesforceUsername: {
        required
      },
      salesforcePassword: {
        required
      },
      salesforceSecurityToken: {
        required
      },
      repoId: {
        required
      },
      syncIntervalInMinutes: {
        required,
        numeric
      },
      playerId: {
        required
      },
      sftpHost: {
        required,
        customHost: or(hostname, ipAddress)
      },
      sftpDataDirectory: {
        required
      }
    },

    watch: {
      connectorName (val) {
        if (val) {
          this.connectorNameState = null
        }
      },
      authURL (val) {
        if (val) {
          this.authURLState = null
        }
      },
      serviceBaseURL (val) {
        if (val) {
          this.serviceBaseURLState = null
        }
      },
      consumerKey (val) {
        if (val) {
          this.consumerKeyState = null
        }
      },
      accessKey (val) {
        if (val) {
          this.accessKeyState = null
        }
      },
      salesforceUsername (val) {
        if (val) {
          this.salesforceUsernameState = null
        }
      },
      salesforcePassword (val) {
        if (val) {
          this.salesforcePasswordState = null
        }
      },
      salesforceSecurityToken (val) {
        if (val) {
          this.salesforceSecurityTokenState = null
        }
      },
      sharedSecret (val) {
        if (val) {
          this.sharedSecretState = null
        }
      },
      repoId (val) {
        if (val) {
          this.repoIdState = null
        }
      },
      syncIntervalInMinutes (val) {
        if (val) {
          this.syncIntervalState = null
        }
      },
      playerId (val) {
        if (val) {
          this.playerIdState = null
        }
      },
      sftpHost (val) {
        if (val) {
          this.sftpHostState = null
        }
      },
      sftpDataDirectory (val) {
        if (val) {
          this.sftpDataDirectoryState = null
        }
      }
    },

    mounted () {
      if (this.uuid) {
        this.loadConnector()
      }
    },

    methods: {
      ...mapActions([
        'createConnector',
        'loadConnectorDetail'
      ]),

      cancel () {
        this.$router.go(-1)
      },

      save () {
        this.$v.$touch()
        if (this.checkValidationStatus()) {
          this.$refs.loadingModal.show()
          let connector = {
            connectorName: this.connectorName,
            description: this.description,
            type: this.type,
            lmsType: this.lmsType,
            userMapping: this.userMapping,
            authType: this.authType,
            repoId: this.repoId,
            playerId: this.playerId,
            authURL: this.authURL,
            launchURL: this.serviceBaseURL,
            consumerKey: this.consumerKey,
            accessKey: this.accessKey,
            sharedSecret: this.sharedSecret,
            serviceBaseURL: this.serviceBaseURL,
            createContentAs: this.createContentAs,
            importContentAs: this.importContentAs,
            syncIntervalInMinutes: this.syncIntervalInMinutes,
            salesforceUsername: this.salesforceUsername,
            salesforcePassword: this.salesforcePassword,
            salesforceSecurityToken: this.salesforceSecurityToken
          }
          if (this.lmsType === 'SFTP') {
            connector.authURL = this.sftpHost
            connector.launchURL = this.sftpHost
            connector.serviceBaseURL = this.sftpHost
            let dataLocation = this.sftpDataDirectory
            if (!dataLocation.startsWith('/')) {
              dataLocation = '/' + dataLocation
            }
            connector.sftpDataDirectory = dataLocation
          }
          let status = 'success'
          let text = 'Connector "' + this.connectorName + '" created successfully.'
          if (this.uuid) {
            connector.uuid = this.uuid
            text = 'Connector "' + this.connectorName + '" updated successfully.'
          }
          this.createConnector(connector).then(res => {
            if (res) {
              if (res.status === 409) {
                text = 'Connector "' + this.connectorName + '" already exists.'
                status = 'warn'
              }
              this.$notify({
                group: 'notify',
                type: status,
                title: '',
                text: text
              })
            }
            setTimeout(() => {
              this.$refs.loadingModal.hide()
              return this.$router.push({name: 'connectorList'})
            }, 500)
          })
        }
      },

      loadConnector () {
        this.loadConnectorDetail(this.uuid).then(res => {
          if (res) {
            this.connectorName = res.connectorName
            this.description = res.description
            this.type = res.type
            this.lmsType = res.lmstype
            this.userMapping = res.userMapping
            this.authType = res.authtype
            this.repoId = res.repoId
            this.playerId = res.playerId
            this.authURL = res.authURL
            this.launchURL = res.serviceBaseURL
            this.consumerKey = res.consumerKey
            this.accessKey = res.accessKey
            this.sharedSecret = res.sharedSecret
            this.serviceBaseURL = res.serviceBaseURL
            this.createContentAs = res.createAs
            this.importContentAs = res.importContentAs
            this.syncIntervalInMinutes = res.syncIntervalInMinutes
            this.salesforceUsername = res.salesforceUsername
            this.salesforcePassword = res.salesforcePassword
            this.salesforceSecurityToken = res.salesforceSecurityToken
            if (this.lmsType === 'SFTP') {
              this.sftpHost = res.authURL
              this.sftpDataDirectory = res.sftpDataDirectory
            }
          }
        })
      },

      checkValidationStatus () {
        let isValid = true
        if (this.$v.connectorName.$error) {
          this.connectorNameState = false
          isValid = false
        }
        if (this.lmsType === 'PopuliV2') {
          if (this.$v.accessKey.$error) {
            this.accessKeyState = false
            isValid = false
          }
        }
        if (this.lmsType === 'Salesforce') {
          if (this.$v.consumerKey.$error) {
            this.consumerKeyState = false
            isValid = false
          }
          if (this.$v.sharedSecret.$error) {
            this.sharedSecretState = false
            isValid = false
          }
          if (this.$v.salesforceUsername.$error) {
            this.salesforceUsernameState = false
            isValid = false
          }
          if (this.$v.salesforcePassword.$error) {
            this.salesforcePasswordState = false
            isValid = false
          }
          if (this.$v.salesforceSecurityToken.$error) {
            this.salesforceSecurityTokenState = false
            isValid = false
          }
        }

        if (this.lmsType !== 'Google' && this.lmsType !== 'Salesforce') {
          if (this.lmsType === 'SFTP') {
            if (this.$v.sftpHost.$error) {
              this.sftpHostState = false
              isValid = false
            }
            if (this.$v.sftpDataDirectory.$error) {
              this.sftpDataDirectoryState = false
              isValid = false
            }
            if (this.$v.consumerKey.$error) {
              this.consumerKeyState = false
              isValid = false
            }
            if (this.$v.sharedSecret.$error) {
              this.sharedSecretState = false
              isValid = false
            }
          } else {
            if (this.$v.authURL.$error) {
              this.authURLState = false
              isValid = false
            }
            if (this.$v.serviceBaseURL.$error) {
              this.serviceBaseURLState = false
              isValid = false
            }
            if ((this.lmsType === 'D2L') || (this.lmsType === 'OKTA') || (this.lmsType === 'Lumens') || (this.lmsType === 'Canvas') || (this.lmsType === 'Skyprep') || (this.lmsType === 'Unmudl') || (this.lmsType === 'Fedora') || (this.lmsType === 'Kaltura')) {
              if (this.$v.consumerKey.$error) {
                this.consumerKeyState = false
                isValid = false
              }
              if (this.$v.sharedSecret.$error) {
                this.sharedSecretState = false
                isValid = false
              }
              if ((this.lmsType === 'Fedora') || (this.lmsType === 'Kaltura')) {
                if (this.$v.repoId.$error) {
                  this.repoIdState = false
                  isValid = false
                }
                if (this.$v.syncIntervalInMinutes.$error) {
                  this.syncIntervalState = false
                  isValid = false
                }
                if (this.lmsType === 'Kaltura') {
                  if (this.$v.playerId.$error) {
                    this.playerIdState = false
                    isValid = false
                  }
                }
              }
            }
          }
        }
        return isValid
      }
    }
  }
</script>

<style scoped>
  .icon-plug {
    color: #157099;
    font-size: 32px !important;
  }

  sup {
    color: red;
  }

  .field-row-radio {
    display: inline-flex;
    margin-right: 0.5rem;
  }

  .field-row-radio input {
    margin-right: 10px;
    margin-top: 3px;
    height: 18px;
    width: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/app/connector/components/ConnectorCreate.vue